import React from 'react'
import { Helmet } from 'react-helmet-async'
import AppContent from 'src/components/app-content'
import { StyledPageContainer } from 'src/components/styled-components'
import StandaloneChat from 'src/components/standalone-chat'

export default function StandaloneChatPage() {
  return (
    <>
      <Helmet>
        <title>Chat with Senior Helpers</title>
      </Helmet>
      <AppContent>
        <StyledPageContainer maxWidth="sm">
          <StandaloneChat />
        </StyledPageContainer>
      </AppContent>
    </>
  )
}